// extracted by mini-css-extract-plugin
export default {"hidden":"BackToTopButton_hidden__pCgrF","toTop":"BackToTopButton_toTop__NYWCJ"};